import { Trans, useTranslation } from 'react-i18next';

import { privacyPolicyUrl } from '~/utils/playerConsent';

type Props = {
    className?: string;
};

/**
 * Mention discrète « Vos données sont traitées selon notre politique de
 * confidentialité », pour les écrans joueur qui collectent des données
 * (profil manette, email du coupon, réglages).
 *
 * La langue du lien suit la langue AFFICHÉE (celle de l'appareil sur la manette,
 * cf. gotcha #180), pas celle de l'établissement.
 */
export function PrivacyNotice({ className }: Props) {
    const { i18n } = useTranslation();
    const href = privacyPolicyUrl(i18n.resolvedLanguage || i18n.language);
    return (
        <p className={className}>
            <Trans
                i18nKey="playerConsent.privacy"
                components={{
                    // Le texte du lien est injecté par <Trans> depuis la traduction.
                    // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
                    link: <a href={href} target="_blank" rel="noopener noreferrer" />,
                }}
            />
        </p>
    );
}
